export default "__VITE_ASSET__$mIjrrjM__"